"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TwitchApiClient = void 0;
exports.convertTwurpleRawData = convertTwurpleRawData;
const api_1 = require("@twurple/api");
const common_1 = require("@twurple/common");
const auth_1 = require("@twurple/auth");
// Helper function to extract raw data from @twurple class instances using official API
function convertTwurpleRawData(obj) {
    // Use @twurple's official getRawData function
    return (0, common_1.getRawData)(obj);
}
class TwitchApiClient {
    apiClient;
    clientId;
    clientSecret;
    eventSubConfig;
    constructor(options) {
        this.clientId = options.client_id;
        this.clientSecret = options.client_secret;
        this.eventSubConfig = options.eventSub;
        // Use user access token if provided, otherwise use app token
        const authProvider = options.access_token
            ? new auth_1.StaticAuthProvider(this.clientId, options.access_token, options.scopes)
            : new auth_1.AppTokenAuthProvider(this.clientId, this.clientSecret);
        this.apiClient = new api_1.ApiClient({ authProvider });
    }
    async getSubscriptions(params) {
        // Use paginated methods to fetch all pages of results
        if (params?.status) {
            return this.apiClient.eventSub
                .getSubscriptionsForStatusPaginated(params.status)
                .getAll();
        }
        else if (params?.type) {
            return this.apiClient.eventSub
                .getSubscriptionsForTypePaginated(params.type)
                .getAll();
        }
        else if (params?.user_id) {
            return this.apiClient.eventSub
                .getSubscriptionsForUserPaginated(params.user_id)
                .getAll();
        }
        else {
            return this.apiClient.eventSub.getSubscriptionsPaginated().getAll();
        }
    }
    async createSubscription(userId, type, version = "1") {
        if (!this.eventSubConfig) {
            throw new Error("EventSub configuration not provided");
        }
        try {
            const subscription = await this.apiClient.eventSub.createSubscription(type, version, {
                broadcaster_user_id: userId,
            }, {
                method: "webhook",
                callback: this.eventSubConfig.webhookUrl,
                secret: this.eventSubConfig.secret,
            });
            return subscription;
        }
        catch (error) {
            console.error(`Failed to create ${type} subscription for user ${userId}:`, error);
            throw error;
        }
    }
    async deleteSubscription(id) {
        try {
            await this.apiClient.eventSub.deleteSubscription(id);
            return { success: true };
        }
        catch (error) {
            console.error(`Failed to delete subscription ${id}:`, error);
            throw error;
        }
    }
    async clearSubscriptions() {
        try {
            await this.apiClient.eventSub.deleteAllSubscriptions();
        }
        catch (error) {
            console.error(error);
            throw error;
        }
    }
    async subscribeToStreamEvents(data) {
        const { channel, userId, events } = data;
        const subscriptions = events.map((event) => {
            console.log(`Creating ${event} event subscription for ${channel}`);
            return this.createSubscription(userId, event);
        });
        return await Promise.allSettled(subscriptions);
    }
    async getStreams(filter) {
        try {
            const streams = await this.apiClient.streams.getStreams(filter);
            if (!streams) {
                return [];
            }
            const result = streams.data.map((stream) => convertTwurpleRawData(stream));
            return result;
        }
        catch (error) {
            console.error(`Failed to get streams:`, error);
            return [];
        }
    }
    async getCurrentUserData(accessToken, withEmail = false) {
        try {
            const tokenInfo = await (0, auth_1.getTokenInfo)(accessToken);
            if (!tokenInfo || !tokenInfo.userId) {
                const error = `Failed to get current user: no valid token found!`;
                console.error(error);
                throw error;
            }
            const user = await this.apiClient.users.getAuthenticatedUser(tokenInfo.userId, withEmail);
            return convertTwurpleRawData(user);
        }
        catch (error) {
            console.error(`Failed to get current user:`, error);
            throw error;
        }
    }
    async getUserByName(name) {
        try {
            const user = await this.apiClient.users.getUserByName(name);
            if (!user)
                return null;
            return convertTwurpleRawData(user);
        }
        catch (error) {
            console.error(`Failed to get user by name ${name}:`, error);
            throw error;
        }
    }
    async getUserById(id) {
        try {
            const user = await this.apiClient.users.getUserById(id);
            if (!user)
                return null;
            return convertTwurpleRawData(user);
        }
        catch (error) {
            console.error(`Failed to get user by id ${id}:`, error);
            throw error;
        }
    }
}
exports.TwitchApiClient = TwitchApiClient;
__exportStar(require("./types/index"), exports);
exports.default = TwitchApiClient;
//# sourceMappingURL=index.js.map